//@ts-check
import ejs from 'ejs';
import dayjs from 'dayjs';
import { openAlert } from '../components/kf-alert';
import { CacheHolder } from '../cache/CacheHolder';
import { SERVER_LIST } from '../constants';
export const isValidJSON = obj => {
  try {
    JSON.parse(obj);
    return true;
  } catch (e) {
    return false;
  }
};

export const parseJson = (json, def) => {
  try {
    return json ? JSON.parse(json) : def;
  } catch (error) {
    return def;
  }
};

export const getURLParameters = url =>
  (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
    (a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a),
    {}
  );

/**
 * 
 * @param {string} txt 
 * @returns {string}
 */
const decodeHtml = (txt) => {
  return txt.replace('&amp;', '&')
    .replaceAll('&lt;', '<')
    .replaceAll('&gt;', '>')
    .replaceAll('&#34;', '"')
    .replaceAll('&#39;', '\'');
};

const tplCache = new CacheHolder(80);
const compileTpl = (tpl, options) => {
  if (tplCache.has(tpl)) {
    return tplCache.get(tpl);
  }
  const fn = ejs.compile(tpl, options);
  tplCache.set(tpl, fn);
  return fn;
};
/**
 * @param {string} template 
 * @param {ejs.Data} data 
 * @param {any | undefined} [def]
 * @param {ejs.Options | undefined} [options]
 * @returns {any | undefined}
 */
export const renderTpl = (template, data, def, options) => {
  try {
    const render = compileTpl(template, options);
    const result = render(data);
    return typeof result === 'string' ? decodeHtml(result) : result;
  } catch (e) {
    if (typeof def === 'function')
      return def(e);
    return def;
  }
};

const INTERVAL = 15 * 1000 * 60;
let timeAlert = 0;
export const renderTplNum = (template, data, def) => {
  const res = renderTpl(template, data, def);
  if (Number.isNaN(Number(res))) {
    if (INTERVAL < dayjs().valueOf() - timeAlert) {
      timeAlert = dayjs().valueOf();
      openAlert(`下記の計算式でエラーが発生しています。\n${template}`);
      console.error(`template result: ${res}`);
    }
    return def;
  } else {
    return Number(res);
  }
};

export const hexToRgb = (hex) => {
  const color = parseInt(hex.replace('#', ''), 16);
  let r = String((color >> 16) & 255);
  let g = String((color >> 8) & 255);
  let b = String(color & 255);
  r = r.length == 1 ? '0' + r : r;
  g = g.length == 1 ? '0' + g : g;
  b = b.length == 1 ? '0' + b : b;
  return `rgb(${r},${g},${b})`;
};

export const pickTextColor = (hex) => {
  if (hex == null || hex == '') {
    return '#000';
  }
  const color = parseInt(hex.replace('#', ''), 16);
  const r = (color >> 16) & 255;
  const g = (color >> 8) & 255;
  const b = color & 255;
  
  // Luminance と Contrast を使った計算式 (W3C recommended)
  /*
  const calcC = (color) => {
    const c = color / 255.0;
    return c <= 0.04045 ? (c / 12.92) : ((c + 0.055) / 1.055) ** 2.4;
  };
  const L = 0.2126 * calcC(r) + 0.7152 * calcC(g) + 0.0722 * calcC(b);
  return L > 0.179 ? '#000' : '#fff';
  */

  // Color Intensity を使った計算式
  if (hex == '#00FFFF' || hex == '#0FF') return '#000';
  return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) ? '#000' : '#fff';
};

export const rgbToHex = (color) => {
  const col = color.replace('rgb(', '').replace(')', '').split(',');
  let r = parseInt(col[0], 10).toString(16);
  let g = parseInt(col[1], 10).toString(16);
  let b = parseInt(col[2], 10).toString(16);
  r = r.length == 1 ? '0' + r : r;
  g = g.length == 1 ? '0' + g : g;
  b = b.length == 1 ? '0' + b : b;
  return '#' + r + g + b;
};

export const shadeColor = (color, percent) => {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);
  R = Math.floor(R * (100 + percent) / 100);
  G = Math.floor(G * (100 + percent) / 100);
  B = Math.floor(B * (100 + percent) / 100);
  R = (R < 255) ? R : 255;
  G = (G < 255) ? G : 255;
  B = (B < 255) ? B : 255;
  const RR = ((R.toString(16).length == 1) ? '0' + R.toString(16) : R.toString(16));
  const GG = ((G.toString(16).length == 1) ? '0' + G.toString(16) : G.toString(16));
  const BB = ((B.toString(16).length == 1) ? '0' + B.toString(16) : B.toString(16));
  return '#' + RR + GG + BB;
};

export const hoverColor = (color, percent) => {
  const textColor = pickTextColor(color);
  return shadeColor(color, textColor == '#000' ? percent : -percent);
};

const isAppleTabletOnIos13 = (navigator) => {
  return (
    typeof navigator !== 'undefined' &&
    navigator.platform === 'MacIntel' &&
    typeof navigator.maxTouchPoints === 'number' &&
    navigator.maxTouchPoints > 1 &&
    // @ts-ignore
    typeof window.MSStream === 'undefined'
  );
};

export const isMobile = () => {
  const ua = navigator.userAgent;
  return ua.includes('iPhone')
    || ua.includes('iPad')
    || ua.includes('iPod')
    || ua.includes('Android')
    || ua.includes('BlackBerry')
    || ua.includes('IEMobile')
    || isAppleTabletOnIos13(navigator);
};

export const createUserTpl = (user, userSetting) => {
  if (user == null) {
    return { ext: {} };
  }
  const tpl = { ...user, ext: {} };
  tpl.urlMap = tpl.addr1 ? `https://maps.google.co.jp/maps?q=${tpl.addr1?.replace(/\s/g, '+')}` : '';
  if (userSetting == null) {
    return tpl;
  }
  const likingEntity = userSetting.likingList.datas;
  const clsEntity = userSetting.clsList.datas;
  const extEntity = userSetting.extList;
  const cls = (tpl.cls == '' || tpl.cls == null) ? clsEntity.byId[clsEntity.allIds?.[0]] : clsEntity.byId[tpl.cls];
  tpl.cls = cls?.label || '';
  const likingList = tpl.liking ? tpl.liking.split(',') : [];
  tpl.likingList = likingList.map(l => likingEntity.byId[l]?.label).filter(l => !!l);
  tpl.liking = tpl.likingList.join(',');
  tpl.ext = {};
  extEntity.allIds.forEach((extId) => {
    const ext = extEntity.byId[extId];
    const key = `ext${ext.dataIdx}`;
    const value = tpl[key];
    if (ext && ext.viewType == 5) {
      tpl.ext[ext.label] = { label: value, value };
    } else {
      const select = { ...(ext.selectList.datas.find(data => data.id == value) || {}) };
      if (select?.label) select.value = select.label;
      tpl.ext[ext.label] = select;
    }
  });
  return tpl;
};

export const getMiscName = (viewMisc) => {
  return viewMisc == 1 ? '厚生費' : '雑費';
};

export const checkEjsTemplate = (template = '') => {
  template = template.trim();
  return template === ''
  || (template.startsWith('<%') && template.endsWith('%>'));
};

export const isState2Default = (states) => {
  const state2 = states?.byId?.['2'];
  if (state2 == null) {
    return false;
  }
  const data = state2?.datas?.byId?.['0'];
  if (data == null) {
    return false;
  }
  return data?.label == '行移動';
};
